<template>
    <div>
       视图模组
    </div>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>
